import { render, staticRenderFns } from "./VideoContain.vue?vue&type=template&id=198a3b5a&scoped=true&"
import script from "./VideoContain.vue?vue&type=script&lang=js&"
export * from "./VideoContain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198a3b5a",
  null
  
)

export default component.exports